import React, { useState } from 'react';
import axios from 'axios';
import './UploadFile.css'

export default function UploadFile() {
  const [selectedFile, setSelectedFile] = useState(null);

  function onChangeHandler(event) {
    setSelectedFile(event.target.files[0])
    console.log(event.target.files[0])
  }

  function onClickHandler() {
    const data = new FormData() 
    data.append('file', selectedFile)
    axios.post(`${process.env.REACT_APP_BACKEND_URL}api/v1/users/upload`, data, {})
      .then(res => {
        console.log(res.statusText)
      })
  }
  
  return(
    <div className="course-list">
      uploadfile
      <input type="file" name="file" onChange={onChangeHandler}/>
      <button type="button" clalssname="btn btn-success btn-block" onClick={onClickHandler}>Upload</button> 
    </div>
  )
}
